<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-secondary my-auto pointer text-white"
            [routerLink]="[URL_SOURCE ? URL_SOURCE : '/']">

        </i>

        <a class=" d-flex align-items-center  text-secondary f18 my-auto dirI text-white">

            <span [routerLink]="['/']"> {{ webAppName }} </span>

        </a>

    </div>

</div>

<div *ngIf="car">

    <div class="container-fluid d-flex">

        <div class="d-flex justify-content-between mt-2 col-12">

            <div class=" text-start flex-column br-end col-6 d-flex flex-column">

                <div class="justify-content-end d-flex">

                    <div class="containerpl px-2">
                        <div class="license-plate">
                            <div class="blue-column">
                                <div class="flag">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="text">
                                    <div>I.R.</div>
                                    <div>IRAN</div>
                                </div>
                            </div>

                            <span>
                                {{car.plak[0] | faNum}}

                            </span>
                            <span class="alphabet-column">
                                {{car.plak[1] | faNum}}

                            </span>
                            <span>
                                {{car.plak[2] | faNum}}
                            </span>
                            <div class="iran-column">
                                <span>ایــران</span>
                                <strong>{{car.plak[4] | faNum}}
                                </strong>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="ps-2 my-auto text-secondary"> :پلاک </p> -->
                </div>

                <p class="ps-2 m-0 text-secondary f-mobile"> تاریخ آخرین لاگ :

                    <span class="text-primary"> {{car.strDate | faNum}}</span>

                </p>

                <p class="ps-2 m-0 text-secondary f-mobile"> ساعت آخرین لاگ :

                    <span class="text-primary">

                        {{car.strTime | faNum}}

                    </span>

                </p>

                <p class="ps-2 m-0 text-secondary f-mobile"> ساعت کارکرد :

                    <span class="text-primary">

                        {{car.iDurationOfOperation | faNum}}

                    </span>

                </p>

                <ng-container *ngIf="car.tiMobileType == 99">

                    <p class="ps-2 m-0 text-secondary f-mobile"> سرعت :

                        <span class="text-primary"> {{car.iSpeed | faNum}} کیلومتر بر ساعت</span>

                    </p>

                    <p class="ps-2 m-0 text-secondary f-mobile dirI"> کیلومتر فعلی (km) :

                        <span class="text-primary">

                            {{otherService.getSeparatedValue(car.fLastKM)}}

                        </span>

                    </p>

                </ng-container>

                <p class="ps-2 m-0 text-secondary f-mobile">موبایل راننده :

                    <span class="text-primary">

                        {{car.strMobile | faNum}}

                    </span>

                </p>

                <p *ngIf="car.strAddress != ''" class="ps-2 m-0 text-secondary f-mobile"> محل فعلی :

                    <span class="text-primary">

                        {{ car.strAddress | faNum}}

                    </span>

                </p>

                <!-- ماشین اداری -->

                <ng-container *ngIf="car?.bOfficial">

                    <p class="ps-2 m-0 text-secondary f-mobile"> وضعیت سفر :

                        <span class="text-primary">

                            {{car.strOfficialStatus_strComment | faNum}}

                        </span>

                    </p>

                </ng-container>

            </div>

            <div class=" text-start flex-column col-6 br-end">

                <p class="px-2 mb-0">

                    <img *ngIf="car.strMobileIcon" class="ms-1" src="data:image/jpeg;base64,{{car.strMobileIcon}}">

                </p>

                <div class="d-flex justify-content-end mt-2 align-items-center">

                    <span *ngIf="car.strFullName" [ngClass]="car.tiValidationStatus < 1 ? 'ps-2' : '' "
                        class="text-primary d-flex justify-content-center align-items-center">

                        {{ car.strFullName }} {{ car.strPersonnelID }}

                        <i *ngIf="car.tiValidationStatus != 0" class="mx-2 fa fa-lg fa-check-circle-o" [ngClass]="car.tiValidationStatus == 2 ? 'text-success' :
                            
                            car.tiValidationStatus == 1 ? 'text-primary' :
                            
                            car.tiValidationStatus == 3 ? 'text-danger' : '' ">

                        </i>

                    </span>

                </div>

                <p class="ps-2 m-0 text-secondary ">نوع :

                    <span class="text-primary">

                        {{car.strMobileType_strComment}}

                    </span>

                </p>

                <p class="ps-2 m-0 text-secondary "> تیپ :

                    <span class="text-primary">

                        {{car.strVehicleType != '' ? car.strVehicleType : 'نامشخص'}}

                    </span>

                </p>

                <ng-container *ngIf="car.bTanker == 1">

                    <p class="ps-2 m-0 text-secondary f-mobile dirI"> نوع تانکر :

                        <span class="text-primary">

                            {{ car.strMaterialType_strComment }}

                        </span>

                    </p>

                    <p class="ps-2 m-0 text-secondary f-mobile dirI"> ظرفیت تانکر (لیتر) :

                        <span class="text-primary">

                            {{ car.fCapacity.toLocaleString() | faNum }}

                        </span>

                    </p>

                    <p class="ps-2 m-0 text-secondary f-mobile dirI"> ارتفاع فعلی مایع (mm) :

                        <span class="text-primary">

                            {{ car.iLiquidHeight.toLocaleString() | faNum }}

                        </span>

                    </p>

                    <p class="ps-2 m-0 text-secondary f-mobile dirI"> ارتفاع کل (mm) :

                        <span class="text-primary">

                            {{ car.iTankHeight.toLocaleString() | faNum }}

                        </span>

                    </p>

                </ng-container>

                <p *ngIf="car.strDeviceStatus_strComment" class="ps-2 m-0 text-secondary f-mobile"> وضعیت :

                    <span class="text-danger"> {{car.strDeviceStatus_strComment }}</span>

                </p>

                <ng-container *ngIf="car.tiMobileType != 99">

                    <p class="ps-2 m-0 text-secondary f-mobile"> سرعت :

                        <span class="text-primary"> {{car.iSpeed | faNum}} کیلومتر بر ساعت</span>

                    </p>

                    <p class="ps-2 m-0 text-secondary f-mobile dirI"> کیلومتر فعلی (km) :

                        <span class="text-primary">

                            {{otherService.getSeparatedValue(car.fLastKM)}}

                        </span>

                    </p>

                </ng-container>

                <p class="ps-2 m-0 text-secondary f-mobile"> پایان اعتبار :

                    <span class="text-primary"> {{car.strValidDate | faNum }} </span>

                </p>

            </div>

        </div>

    </div>

    <hr class=" mx-auto my-2">

    <div class="col-12 d-flex justify-content-around flex-wrap px-1 px-md-3 ">

        <div class="col-md-12 row gx-0 gy-0 justify-content-center m-0 dirI">

            <!-- وزن فعلی -->
            <ng-container *ngIf="car?.bWeightSensor == 1">

                <div class="car-filed border-end border-1 col-2 p-2">

                    <img src="../../../assets/Img/weight.png" loading="lazy" alt="وزن فعلی">

                    <small class="mt-1"> وزن فعلی : {{ car?.fWeight | faNum }} تن </small>

                </div>

            </ng-container>

            <!-- دمای فعلی -->
            <ng-container *ngIf="car?.bTemperatureSensor == 1">

                <div class="car-filed col-2 p-2">

                    <img src="../../../assets/Img/temperature.png" loading="lazy" alt="دمای فعلی">

                    <small class="mt-1"> دمای فعلی : {{ car?.iTemperature | faNum }} درجه </small>

                </div>

            </ng-container>

            <!-- ولتاژ خودرو -->
            <ng-container>

                <div class="car-filed col-2 p-2">

                    <img src="../../../assets/Img/charge.png" loading="lazy" alt="ولتاژ خودرو">

                    <small class="mt-1"> ولتاژ خودرو : {{ car?.fPower | faNum }} ولت </small>

                </div>

            </ng-container>

            <!-- ولتاژ باتری -->
            <ng-container>

                <div class="car-filed col-2 p-2">

                    <img src="../../../assets/Img/battery.png" loading="lazy" alt="ولتاژ باتری">

                    <small class="mt-1"> باتری : {{ car?.fBattery | faNum }} ولت </small>

                </div>

            </ng-container>

            <!-- سوخت -->
            <ng-container *ngIf="car?.bFuelSensor">

                <div class="car-filed col-2 p-2">

                    <img src="../../../assets/Img/gas.png" loading="lazy" alt="سوخت">

                    <small class="mt-1"> سوخت : {{ car?.iFuel || 0 | faNum }} لیتر </small>

                </div>

            </ng-container>

            <!-- حجم -->
            <ng-container *ngIf="car.bTanker == 1">

                <div class="car-filed col-2 p-2">

                    <img src="../../../assets/Img/water-tank.png" loading="lazy" alt="حجم">

                    <small class="mt-1"> حجم : {{ car?.fVolume || 0 | faNum }} لیتر </small>

                </div>

            </ng-container>

        </div>

    </div>


    <hr class=" mx-auto my-2">

</div>

<div class="d-flex justify-content-around flex-wrap flex-row-reverse">

    <!-- عملیات -->

    <div class="col-lg-3 col-md-4 col-6 mt-2" data-bs-toggle="modal" data-bs-target="#Operation_Modal">

        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

            <img src="../../../assets/Img/عملیات.png" class="img-person mx-auto mt-2">

            <p class="text-center text-primary"> عملیات </p>

        </div>

    </div>

    <!-- سوخت گیری -->

    <div class="col-lg-3 col-md-4 col-6 mt-2" [routerLink]="['/refule/',Id]" *ngIf="acssess.bRefueling">

        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

            <img src="../../../assets/Img/5727889_fuel_gas_gasolene_gasoline_petrol_icon (1).png"
                class="img-person mx-auto mt-2">

            <p class="text-center text-primary">سوخت گیری</p>

        </div>

    </div>

    <!-- موقعیت و ردیابی -->

    <div class="col-lg-3 col-md-4 col-6 pointer" [routerLink]="['/tracker/',Id]"
        [ngClass]="showLocation  ? 'index-1' : ''">

        <div class="col-11 shadow d-flex justify-content-center flex-column rounded me-auto"
            [ngClass]="showLocation  ? 'disabled' : ''">

            <img src="../../../assets/Img/ردیابی.png" class="img-person mx-auto mt-2">

            <p class="text-center text-primary">موقعیت و ردیابی </p>

        </div>

    </div>

    <!-- مسیر -->

    <div class="col-lg-3 col-md-4 col-6" data-bs-toggle="modal" data-bs-target="#exampleModal"
        [ngClass]="showLocation  ? 'index-1' : ''">

        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto"
            [ngClass]="showLocation  ? 'disabled' : ''">

            <img src="../../../assets/Img/مسیر.png" class="img-person mx-auto mt-2">

            <p class="text-center text-primary">مسیر</p>

        </div>

    </div>

    <!-- گزارش ها -->

    <div class="col-lg-3 col-md-4 col-6 mt-2" (click)="selectOperation('bAllOperations')" data-bs-toggle="modal"
        data-bs-target="#reportModal">

        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

            <img src="../../../assets/Img/گزارش-ها.png" class="img-person mx-auto mt-2">

            <p class="text-center text-primary">گزارش ها</p>

        </div>

    </div>

    <!-- محدوده مجاز  -->

    <div class="col-lg-3 col-md-4 col-6  pointer" [routerLink]="['/carArea/',Id]"
        [ngClass]="showLocation  ? 'index-1' : ''" *ngIf="acssess.bDefGeoFance">

        <div class="col-11 shadow d-flex justify-content-center flex-column rounded me-auto"
            [ngClass]="showLocation  ? 'disabled' : ''">

            <img src="../../../assets/Img/1847182-200.png" class="img-person mx-auto mt-2">

            <p class="text-center text-primary">محدوده مجاز </p>

        </div>

    </div>

    <!-- درآمد ها -->

    <div class="col-lg-3 col-md-4 col-6 mt-2" [routerLink]="['/income/',Id]" *ngIf="acssess.bEnableCarRvenues">

        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

            <img src="../../../assets/Img/درآمد.png" class="img-person mx-auto mt-2">

            <p class="text-center text-primary">درآمد ها</p>

        </div>

    </div>

    <!-- ارسال فرمان -->

    <div *ngIf="acssess.bEnableCommand" class="col-lg-3 col-md-4 col-6 mt-2" [ngClass]="showLocation  ? 'index-1' : ''"
        data-bs-toggle="modal" data-bs-target="#exampleModal6" (click)="updateCommand(true)">

        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto"
            [ngClass]="showLocation  ? 'disabled' : ''">

            <img src="../../../assets/Img/ارسال-فرم.png" class="img-person mx-auto mt-2">

            <p class="text-center text-primary">ارسال فرمان</p>

        </div>

    </div>

    <!-- تحویل و تحول خودرو  -->

    <div class="col-lg-3 col-md-4 col-6 mt-2" [routerLink]="['/transformation/',Id]" *ngIf="acssess.bTransformation">

        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

            <img src="../../../assets/Img/تحویل و تحول خودرو.png" style="width: auto!important;"
                class="img-person mx-auto mt-2">

            <p class="text-center text-primary">تحویل و تحول خودرو </p>

        </div>

    </div>

    <!-- موتور ECU اطلاعات  -->
    <div *ngIf="car?.bOBD2" class="col-lg-3 col-md-4 col-6 mt-2" [routerLink]="['/fleetdiag/',Id,'workspace']">
        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">
            <img src="../../../assets/Img/موتور ECU اطلاعات.png" style="width: auto!important;"
                class="img-person mx-auto mt-2">
            <p class="text-center text-primary"> موتور ECU اطلاعات </p>
        </div>
    </div>

    <!-- اطلاعات پایه CAN  -->
    <div *ngIf="car?.bOBD2" class="col-lg-3 col-md-4 col-6 mt-2" [routerLink]="['/can/',Id,'basic-info']">
        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">
            <img src="../../../assets/Img/اطلاعات ECU.png" style="width: auto!important;"
                class="img-person mx-auto mt-2">
            <p class="text-center text-primary"> CAN اطلاعات پایه </p>
        </div>
    </div>

    <!-- اطلاعات جامع CAN  -->

    <div *ngIf="car?.bOBD2" class="col-lg-3 col-md-4 col-6 mt-2" [routerLink]="['/can/',Id,'full-info']">

        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

            <img src="../../../assets/Img/CAN اطلاعات جامع.png" style="width: auto!important;"
                class="img-person mx-auto mt-2">

            <p class="text-center text-primary"> CAN اطلاعات جامع </p>

        </div>

    </div>

    <!-- پشتیبانی -->

    <div class="col-lg-3 col-md-4 col-6 mt-2" [routerLink]="['/support/',Id]" *ngIf="acssess.bEnableTiket">

        <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

            <img src="../../../assets/Img/پشتیبانی.png" class="img-person mx-auto mt-2">

            <p class="text-center text-primary">پشتیبانی</p>

        </div>

    </div>

</div>

<div class="row justify-content-center gx-0 gy-2 gy-md-0 my-4 px-3">

    <div *ngIf="car?.bDashCam" class="col-12 col-md-auto px-1">

        <!-- نظارت تصویری قدیمی -->

        <button class="d-none w-100 d-flex justify-content-center align-items-center btn btn-secondary font-info-resp">

            <a [href]="['/surveillance/'+ Id]" target="_blank" class="text-white">

                نظارت تصویری

                <i class="px-2 fa fa-video-camera" aria-hidden="true"></i>

            </a>

        </button>

        <!-- نظارت تصویری جدید -->

        <button class="w-100 d-flex justify-content-center align-items-center btn btn-secondary font-info-resp">

            <a class="text-white" (click)="checkOutOnline_Status()">

                نظارت تصویری

                <i class="px-2 fa fa-video-camera" aria-hidden="true"></i>

            </a>

        </button>

    </div>

    <div *ngIf="acssess.bRouting" class="col-12 col-md-auto px-1">

        <button class="w-100 d-flex justify-content-center align-items-center btn btn-warning font-info-resp"
            (click)="openMap()">

            مسیر یابی به سمت خودرو

            <i class="px-2 fa fa-map" aria-hidden="true"></i>

        </button>

    </div>

    <div *ngIf="hasGps && acssess.bEnableEditCar" class="col-12 col-md-auto px-1">

        <button class="w-100 d-flex justify-content-center align-items-center btn btn-primary" (click)="saveCar(1)">

            ویرایش اطلاعات

            <i class="px-2 fa fa-edit"></i>

        </button>

    </div>

    <div *ngIf="!hasGps && acssess.bEnableEditCar" class="col-12 col-md-auto px-1">

        <button class="w-100 d-flex justify-content-center align-items-center btn btn-primary " (click)="saveCar(2)">

            ویرایش اطلاعات

            <i class="px-2 fa fa-edit"></i>

        </button>

    </div>

    <div class="col-12 col-md-auto px-1">

        <button class="w-100 d-flex justify-content-center align-items-center btn btn-success "
            (click)="openDocumentModal()">

            اسناد و مدارک

            <i class="px-2 fa fa-file-image-o"></i>

        </button>


    </div>

</div>

<!-- Modal -->

<div class="modal fade rtl " id="exampleModal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content ">

            <div class="modal-header">

                <h5 class="modal-title" id="">انتخاب تاریخ</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body col-12 d-flex flex-wrap justify-content-around">

                <div class="col-11 col-md-3 mb-2 mb-md-0">

                    <label class="mb-2"> تاریخ *</label>

                    <form [formGroup]="datasabt">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <div class="col-5 col-md-3">

                    <label class="mb-2"> از ساعت *</label>

                    <div class="input-group clockpicker">

                        <input type="text" class="form-control shadow bg-light" value="00:00" id="StimeR" readonly>

                        <span class="input-group-addon ">

                            <span class="glyphicon glyphicon-time"></span>

                        </span>

                    </div>

                </div>

                <div class="col-5 col-md-3">
                    <label class="mb-2"> تا ساعت *</label>

                    <div class="input-group clockpicker">
                        <input type="text" class="form-control shadow bg-light" value="23:59" id="EtimeR" readonly>
                        <span class="input-group-addon ">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>

                </div>

            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-success" (click)="sabt()">تایید <i
                        class="fa fa-angle-double-down"></i> </button>
                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>

<!-- Modal Report -->

<div class="modal fade rtl " id="reportModal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> {{ reportOp_Title }} </h5>

                <button *ngIf="bAllOperations" type="button" class="btn-close" data-bs-dismiss="modal"
                    aria-label="Close"></button>

                <button *ngIf="!bAllOperations" type="button" class="btn-close"
                    (click)="selectOperation('bAllOperations')">

                </button>

            </div>

            <div class="modal-body row gx-2 gy-3 p-3">

                <div class="row gx-2 gy-3 p-3">

                    <ng-container *ngIf="bAllOperations">

                        <!-- گزارش های عملیاتی -->

                        <div class="col-12 col-md-3 col-lg-4" (click)="selectOperation('bReportOperations')">

                            <div
                                class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                                <img src="../../../assets/Img/گزارش های عملیاتی.png" class="img-person mx-auto mt-2">

                                <p class="mt-2 text-center text-primary"> گزارش های عملیاتی </p>

                            </div>

                        </div>

                        <!-- گزارش های مالی  و محدوده‌ای -->

                        <div class="col-12 col-md-3 col-lg-4" (click)="selectOperation('bFinancialOperations')">

                            <div
                                class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                                <img src="../../../assets/Img/گزارش های مالی  و محدوده‌ای.png"
                                    class="img-person mx-auto mt-2">

                                <p class="mt-2 text-center text-primary"> گزارش های مالی و محدوده‌ای </p>

                            </div>

                        </div>

                        <!-- گزارش های تانکر -->

                        <ng-container *ngIf="car?.bTanker == 1">

                            <div class="col-12 col-md-3 col-lg-4" (click)="selectOperation('bTankerOperations')">

                                <div
                                    class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                                    <img src="../../../assets/Img/گزارش های تانکر.png" class="img-person mx-auto mt-2">

                                    <p class="mt-2 text-center text-primary"> گزارش های تانکر </p>

                                </div>

                            </div>

                        </ng-container>

                        <!-- گزارش های ایاب و ذهاب  -->

                        <ng-container *ngIf="car?.tiMobileGroup == 232">

                            <div class="col-12 col-md-3 col-lg-4" (click)="selectOperation('bSalary')">

                                <div
                                    class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                                    <img src="../../../assets/Img/ایاب ذهاب.png" class="img-person mx-auto mt-2">

                                    <p class="mt-2 text-center text-primary"> گزارش های ایاب و ذهاب </p>

                                </div>

                            </div>

                        </ng-container>

                        <!-- پایش باک سوخت  -->

                        <ng-container *ngIf="car?.bFuelSensor">

                            <div class="col-12 col-md-3 col-lg-4" (click)="selectOperation('bFuelSensor')">

                                <div
                                    class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                                    <img src="../../../assets/Img/گزارش های سوخت.png" loading="lazy"
                                        class="img-person mx-auto mt-2">

                                    <p class="mt-2 text-center text-primary"> پایش باک سوخت </p>

                                </div>

                            </div>

                        </ng-container>

                        <!-- گزارش های وزن  -->

                        <ng-container *ngIf="car?.bWeightSensor == 1">

                            <div class="col-12 col-md-3 col-lg-4" (click)="selectOperation('bWeightSensor')">

                                <div
                                    class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                                    <img src="../../../assets/Img/گزارش های وزن.png" loading="lazy"
                                        class="img-person mx-auto mt-2">

                                    <p class="mt-2 text-center text-primary"> گزارش های وزن </p>

                                </div>

                            </div>

                        </ng-container>

                        <!-- گزارش های دما  -->

                        <ng-container *ngIf="car?.bTemperatureSensor == 1">

                            <div class="col-12 col-md-3 col-lg-4" (click)="selectOperation('bTemperatureSensor')">

                                <div
                                    class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                                    <img src="../../../assets/Img/گزارش های دما.png" loading="lazy"
                                        class="img-person mx-auto mt-2">

                                    <p class="mt-2 text-center text-primary"> گزارش های دما </p>

                                </div>

                            </div>

                        </ng-container>

                        <!-- پایش فلومتر   -->

                        <ng-container *ngIf="car?.bFlowmeter == 1">

                            <div class="col-12 col-md-3 col-lg-4" (click)="selectOperation('bFlowmeter')">

                                <div
                                    class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                                    <img src="../../../assets/Img/پایش فلومتر .png" loading="lazy"
                                        class="img-person mx-auto mt-2">

                                    <p class="mt-2 text-center text-primary"> پایش فلومتر </p>

                                </div>

                            </div>

                        </ng-container>

                    </ng-container>

                    <ng-container *ngIf="bReportOperations">

                        <div class="d-flex flex-wrap justify-content-start">

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bReportStop">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal3">

                                    توقف

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bReportDaily">

                                <button class="btn btn-th-blue  w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal4">

                                    کارکرد

                                </button>

                            </div>

                            <div class="d-none col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bReportExitDomain">

                                <button class="btn btn-th-blue w-200 mt-2">تخلف خروج از محدوده</button>

                            </div>

                            <div class="d-none col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bReportEnterDomain">

                                <button class="btn btn-th-blue w-200 mt-2">تخلف ورود به محدوده</button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bReportRefueling">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal5" (click)="changeApi('13')">

                                    سوختگیری

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bReportViolation">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal5" (click)="changeApi('3')">

                                    تخلف ها رانندگان

                                </button>
                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bReportRepair">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal5" (click)="changeApi('4')">

                                    تعمیرات خودرو

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bReportGPSJournal">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal5" (click)="changeApi('7')">

                                    وقایع ردیاب

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bReportGPSIO">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal5" (click)="changeApi('8')">

                                    ورودی ها ردیاب

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bReportVelocity">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal3" (click)="changeApi('15')">

                                    نمودار سرعت خودرو

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bReportVelocity">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal3" (click)="changeApi('15-3')">

                                    نمودار شتاب

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bServiceDelivery">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal5" (click)="changeApi('19')">

                                    گزارش خدمات رسانی

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bComprehensiveReport">

                                <button class="btn btn-th-blue w-200 mt-2">

                                    گزارش جامع

                                </button>

                            </div>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="bFinancialOperations">

                        <div class="d-flex flex-wrap justify-content-start">

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bSalari">

                                <button class="btn btn-th-blue w-200 mt-2" (click)="salary()">حقوق - ورود خروج </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bSalariBaseZone">

                                <button class="btn btn-th-blue w-200 mt-2" (click)="salaryBaseZone()">حقوق - محدوده
                                    فعالیت </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bReportInOutDomain">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal5" (click)="changeApi('9')">

                                    ورود و خروج به محدوده

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bReportIncome">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal5" (click)="changeApi('5')">

                                    درآمد ها

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bReportIncomeEexpense">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal5" (click)="changeApi('6')">

                                    درآمد ها / هزینه ها

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bFunctionSD">

                                <button class="btn btn-th-blue w-200 mt-2" style="font-size: 15px;"
                                    (click)="sourceDestEarning()">

                                    کارکرد مابین مبدا و مقصد

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bTransportation_DailyReport">

                                <button class="btn btn-th-blue w-200 mt-2" style="font-size: 15px;"
                                    (click)="sourceDestEarning(20)">

                                    عملکرد ایاب و ذهاب

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bMobilesInspection">

                                <button class="btn btn-th-blue w-200 mt-2" (click)="inspectionReport()">

                                    حرکت مابین محدوده ها

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bMobilesInspection">

                                <button class="btn btn-th-blue w-200 mt-2" (click)="inspectionReport('18-0')">

                                    عملکرد مابین محدودها

                                </button>

                            </div>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="bTankerOperations">

                        <div class="d-flex flex-wrap justify-content-start">

                            <div class="d-none col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bTanker_Reports">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal3" (click)="changeApi('15-1')">

                                    <small> تخلیه براساس زمان </small>

                                </button>

                            </div>

                            <div class="d-none col-md-3 col-12 d-flex justify-content-center"
                                *ngIf="acssess.bTanker_Reports">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal3" (click)="changeApi('15-2')">

                                    <small> تخلیه براساس سرعت </small>

                                </button>

                            </div>

                            <div *ngIf="car.tiMobileType == 99" class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal" data-bs-toggle="modal"
                                    data-bs-toggle="modal" data-bs-target="#exampleModal" data-bs-target="#exampleModal"
                                    (click)="bTankerRoute=true">

                                    <small> بررسی عملکرد تانکر </small>

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bTanker_Reports">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal3" (click)="changeApi('1-1');bTankerMood=true">

                                    <small> جزییات تغذیه تانکر </small>

                                </button>

                            </div>

                            <div class="col-md-3 col-12 d-flex justify-content-center" *ngIf="acssess.bTanker_Reports">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal3" (click)="changeApi('1-2');bTankerMood=true">

                                    <small> جزییات تخلیه از تانکر </small>

                                </button>

                            </div>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="bSalary">

                        <div class="d-flex flex-wrap justify-content-start">

                            <!-- مسافرین فعلی -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2" (click)="showAyab_Zahab(1)">

                                    <small> مسافرین فعلی </small>

                                </button>

                            </div>

                            <!-- سرجمع مسافرین -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2" (click)="showAyab_Zahab(2)">

                                    <small> سرجمع مسافرین </small>

                                </button>

                            </div>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="bFuelSensor">

                        <div class="d-flex flex-wrap justify-content-start">

                            <!-- نمودار مصرف براساس زمان -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal4_1">

                                    <small> نمودار مصرف براساس زمان </small>

                                </button>

                            </div>

                            <!-- سوخت گیری -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal4_2">

                                    <small> سوخت گیری </small>

                                </button>

                            </div>

                            <!-- تخلیه های مشکوک -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal4_3">

                                    <small> تخلیه های مشکوک </small>

                                </button>

                            </div>

                            <!-- تحلیل مصرف -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2">

                                    <small> تحلیل مصرف </small>

                                </button>

                            </div>

                            <!-- سوخت خالص مصرفی -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal4_4">

                                    <small> سوخت خالص مصرفی </small>

                                </button>

                            </div>

                            <!-- روند مصرف سوخت -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal4_5">

                                    <small> روند مصرف سوخت </small>

                                </button>

                            </div>

                            <!-- نمودار سوخت مصرفی لحظه‌ای  -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal4_6">

                                    <small> سوخت مصرفی لحظه‌ای </small>

                                </button>

                            </div>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="bWeightSensor">

                        <div class="d-flex flex-wrap justify-content-start">

                            <!-- روند تغییر وزن -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2">

                                    <small> روند تغییر وزن </small>

                                </button>

                            </div>

                            <!-- گزارش های بارگیری -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2">

                                    <small> گزارش های بارگیری </small>

                                </button>

                            </div>

                            <!-- گزارش های تخلیه  -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2">

                                    <small> گزارش های تخلیه </small>

                                </button>

                            </div>

                            <!-- گزارش بارگیری - تخلیه  -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2">

                                    <small> گزارش بارگیری - تخلیه </small>

                                </button>

                            </div>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="bTemperatureSensor">

                        <div class="d-flex flex-wrap justify-content-start">

                            <!-- روند تغییر دما -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2">

                                    <small> روند تغییر دما </small>

                                </button>

                            </div>

                            <!-- تغییرات ناگهانی دما -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2">

                                    <small> تغییرات ناگهانی دما </small>

                                </button>

                            </div>

                        </div>

                    </ng-container>

                    <ng-container *ngIf="bFlowmeter">

                        <div class="d-flex flex-wrap justify-content-start">

                            <!-- نمودار روند جریان -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal4_7">

                                    <small> نمودار روند جریان </small>

                                </button>

                            </div>

                            <!-- سرجمع جریان -->

                            <div class="col-md-3 col-12 d-flex justify-content-center">

                                <button class="btn btn-th-blue w-200 mt-2">

                                    <small> سرجمع جریان </small>

                                </button>

                            </div>

                        </div>

                    </ng-container>

                </div>

            </div>

            <div class="modal-footer"></div>

        </div>

    </div>

</div>

<!-- Modal1 -->

<div class="modal fade rtl " id="exampleModal3" tabindex="-1" aria-labelledby="" aria-hidden="true"
    data-backdrop="false" data-bs-backdrop='static' data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="">بازه مد نظر خود را انتخاب کنید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="bTankerMood=false"></button>
            </div>
            <div class="modal-body d-flex justify-content-around flex-wrap ">


                <div class="col-md-3 col-12 mb-2">

                    <label class="mb-2"> {{bTankerMood ? 'از تاریخ *' : 'تاریخ *' }} </label>

                    <form [formGroup]="datasabtStop">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <div class="col-md-3 col-12 mb-2" *ngIf="bTankerMood">

                    <label class="mb-2"> تا تاریخ *</label>

                    <form [formGroup]="datasabtStop">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="strEDate" class="form-control shadow text-end"
                                readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <ng-container *ngIf="!bTankerMood">

                    <div class="col-md-3 col-6">

                        <label class="mb-2"> از ساعت *</label>

                        <div class="input-group clockpicker">

                            <input type="text" class="form-control shadow bg-light" value="00:00" id="Stime" readonly>

                            <span class="input-group-addon ">

                                <span class="glyphicon glyphicon-time"></span>

                            </span>

                        </div>

                    </div>

                    <div class="col-md-3 col-6">

                        <label class="mb-2"> تا ساعت *</label>

                        <div class="input-group clockpicker">

                            <input type="text" class="form-control shadow bg-light" value="23:59" id="Etime" readonly>

                            <span class="input-group-addon">

                                <span class="glyphicon glyphicon-time"></span>

                            </span>

                        </div>

                    </div>

                </ng-container>
            </div>
            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-success" (click)="ReportStop()">تایید <i
                        class="fa fa-angle-double-down"></i> </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal" (click)="bTankerMood=false">بستن
                    <i class="fa fa-close"></i></button>

            </div>
        </div>
    </div>
</div>

<!--Modal2-->

<div class="modal fade rtl " id="exampleModal4" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="">بازه مد نظر خود را انتخاب کنید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-around flex-wrap ">


                <div class="col-5 mb-2">
                    <label class="mb-2">از تاریخ* </label>
                    <form [formGroup]="dataWorkAz">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>

                </div>
                <div class="col-5 mb-2">
                    <label class="mb-2"> تا تاریخ *</label>
                    <form [formGroup]="dataWorkTa">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>

                </div>
                <div class=" col-5">
                    <!-- <label class="mb-2"> از ساعت *</label>

                    <div class="input-group clockpicker">
                        <select class="form-control bg-light" id="clocks">
                            <option value="0" selected>0</option>

                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                        </select>
                    </div> -->
                    <label class="mb-2"> از ساعت *</label>

                    <div class="input-group clockpicker">
                        <input type="text" class="form-control shadow bg-light" value="00:00" id="clocks" readonly>
                        <span class="input-group-addon ">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>

                </div>
                <div class=" col-5">
                    <!-- <label class="mb-2"> تا ساعت *</label>

                    <div class="input-group clockpicker">
                        <select class="form-control bg-light" id="clocke">
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                            <option value="24" selected>24</option>
                        </select>
                    </div> -->
                    <label class="mb-2"> تا ساعت *</label>

                    <div class="input-group clockpicker">
                        <input type="text" class="form-control shadow bg-light" value="23:59" id="clocke" readonly>
                        <span class="input-group-addon ">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>
                </div>
            </div>
            <div dir="ltr" class="modal-footer">
                <button type="button" class="btn btn-info" (click)="recallDistance()">محاسبه نرم افزاری فاصله ها <i
                        class="fa fa-refresh" id="recal"></i> </button>
                <button type="button" class="btn btn-success" (click)="reportWork()">تایید <i
                        class="fa fa-angle-double-down"></i> </button>
                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade rtl " id="exampleModal4_1" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> بازه مد نظر خود را انتخاب کنید </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex justify-content-around flex-wrap ">

                <!-- از تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2">از تاریخ* </label>

                    <form [formGroup]="dataWorkAz">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <!-- تا تاری -->

                <div class="col-5 mb-2">

                    <label class="mb-2"> تا تاریخ *</label>

                    <form [formGroup]="dataWorkTa">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <!-- از ساعت -->

                <div class=" col-5">

                    <label class="mb-2"> از ساعت *</label>

                    <div class="input-group clockpicker">

                        <input type="text" class="form-control shadow bg-light" value="00:00" id="clocks" readonly>

                        <span class="input-group-addon ">

                            <span class="glyphicon glyphicon-time"></span>

                        </span>

                    </div>


                </div>

                <!-- تا ساعت -->

                <div class=" col-5">

                    <label class="mb-2"> تا ساعت *</label>

                    <div class="input-group clockpicker">

                        <input type="text" class="form-control shadow bg-light" value="23:59" id="clocke" readonly>

                        <span class="input-group-addon ">

                            <span class="glyphicon glyphicon-time"></span>

                        </span>

                    </div>

                </div>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-success" (click)="get_Fueltank()">

                    تایید

                </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">

                    بستن

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade rtl " id="exampleModal4_2" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> بازه مد نظر خود را انتخاب کنید </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex justify-content-around flex-wrap ">

                <!-- از تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2">از تاریخ* </label>

                    <form [formGroup]="dataWorkAz">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <!-- تا تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2"> تا تاریخ *</label>

                    <form [formGroup]="dataWorkTa">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-success" (click)="get_Refueling()">

                    تایید

                </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">

                    بستن

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade rtl " id="exampleModal4_3" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> بازه مد نظر خود را انتخاب کنید </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex justify-content-around flex-wrap ">

                <!-- از تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2">از تاریخ* </label>

                    <form [formGroup]="dataWorkAz">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <!-- تا تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2"> تا تاریخ *</label>

                    <form [formGroup]="dataWorkTa">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-success" (click)="get_Discharge()">

                    تایید

                </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">

                    بستن

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade rtl " id="exampleModal4_4" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> بازه مد نظر خود را انتخاب کنید </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex justify-content-around flex-wrap ">

                <!-- از تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2">از تاریخ* </label>

                    <form [formGroup]="mdl_NetConsumed">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="strSDate" class="form-control shadow text-end"
                                readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <!-- تا تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2"> تا تاریخ *</label>

                    <form [formGroup]="mdl_NetConsumed">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="strEDate" class="form-control shadow text-end"
                                readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-success" (click)="get_NetConsumed()">

                    تایید

                </button>

                <button type="button" class="btn btn-outline-secondary " data-bs-dismiss="modal">

                    بستن

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade rtl " id="exampleModal4_5" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> بازه مد نظر خود را انتخاب کنید </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex justify-content-around flex-wrap ">

                <!-- از تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2">از تاریخ* </label>

                    <form [formGroup]="mdl_NetConsumed">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="strSDate" class="form-control shadow text-end"
                                readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <!-- تا تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2"> تا تاریخ *</label>

                    <form [formGroup]="mdl_NetConsumed">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="strEDate" class="form-control shadow text-end"
                                readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-success" (click)="sabt2()">

                    تایید

                </button>

                <button type="button" class="btn btn-outline-secondary " data-bs-dismiss="modal">

                    بستن

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade rtl " id="exampleModal4_6" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> بازه مد نظر خود را انتخاب کنید </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex justify-content-around flex-wrap ">

                <!-- از تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2">از تاریخ* </label>

                    <form [formGroup]="mdl_Consumption">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="strSDate" class="form-control shadow text-end"
                                readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <!-- تا تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2"> تا تاریخ *</label>

                    <form [formGroup]="mdl_Consumption">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="strEDate" class="form-control shadow text-end"
                                readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-success" (click)="sabt3()">

                    تایید

                </button>

                <button type="button" class="btn btn-outline-secondary " data-bs-dismiss="modal">

                    بستن

                </button>

            </div>

        </div>

    </div>

</div>

<div class="modal fade rtl " id="exampleModal4_7" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> بازه مد نظر خود را انتخاب کنید </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex justify-content-around flex-wrap ">

                <!-- از تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2">از تاریخ* </label>

                    <form [formGroup]="mdl_Consumption">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="strSDate" class="form-control shadow text-end"
                                readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

                <!-- تا تاریخ -->

                <div class="col-5 mb-2">

                    <label class="mb-2"> تا تاریخ *</label>

                    <form [formGroup]="mdl_Consumption">

                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                            <input type="text" formControlName="strEDate" class="form-control shadow text-end"
                                readonly />

                        </ng-persian-datepicker>

                    </form>

                </div>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-success" (click)="submit_Flowtrend()">

                    تایید

                </button>

                <button type="button" class="btn btn-outline-secondary " data-bs-dismiss="modal">

                    بستن

                </button>

            </div>

        </div>

    </div>

</div>

<!--Modal3-->

<div class="modal fade rtl " id="exampleModal5" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="">بازه مد نظر خود را انتخاب کنید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-around flex-wrap ">


                <div class="col-3 mb-2" [ngClass]="api=='7'  ? 'col-3' : 'col-5'">
                    <label class="mb-2">از تاریخ* </label>
                    <form [formGroup]="dataAz">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>

                </div>
                <div class=" mb-2" [ngClass]="api=='7'  ? 'col-3' : 'col-5'">
                    <label class="mb-2"> تا تاریخ *</label>
                    <form [formGroup]="dataTa">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>

                </div>
                <div class="col-3 mb-2" *ngIf="api=='7'">
                    <label class="mb-2">نوع واقعه</label>
                    <select class="form-control" id="deviceEvents">
                        <option value="-1">همه موارد</option>
                        <option *ngFor="let item of deviceEvents" value="{{item.tiDeviceEventsType}}">
                            {{item.strComment}}</option>
                    </select>

                </div>

            </div>
            <div dir="ltr" class="modal-footer">
                <button type="button" class="btn btn-success" (click)="sabtdata()">تایید <i
                        class="fa fa-angle-double-down"></i> </button>
                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>



<!--Sms Modal-->

<!--Modal3-->

<div class="modal fade rtl " id="exampleModal6" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-md">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> ارسال پیام </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="row gx-0 gy-0">

                    <!-- لیست فرامین  -->

                    <div class="col-6 p-1">

                        <div class="w-100 h-100" (click)="updateCommand(true)">

                            <button class="w-100"
                                [ngClass]="isCommandList ? 'btn btn-success' : 'btn btn-outline-success'">

                                لیست فرامین

                            </button>

                        </div>

                    </div>

                    <!-- پاسخ فرمان های ارسالی -->

                    <div class="col-6 p-1">

                        <div class="w-100 h-100" (click)="updateCommand(false)">

                            <button class="w-100"
                                [ngClass]="!isCommandList ? 'btn btn-primary' : 'btn btn-outline-primary'">

                                پاسخ فرمان های ارسالی

                            </button>

                        </div>

                    </div>

                    <!-- جستجو -->

                    <div class="col-12 p-1 mt-1">

                        <div class="w-100 h-100">

                            <input type="text" class="form-control w-100" placeholder="جستجو کنید ..."
                                (keyup)="filter_list($event.target)">

                        </div>

                    </div>

                    <!-- نتیجه فرامین -->

                    <div *ngIf="isCommandList" class="col-12 p-1">

                        <div class="w-100 h-100" style="max-height: 400px;overflow: auto;">

                            <div class="border border-2 mt-2">

                                <table class="table table-striped bg-white mt-1 dirI" id="excel-list">

                                    <thead>

                                        <tr class="text-center">

                                            <th scope="col"> # </th>

                                            <th scope="col"> عملیات </th>

                                            <th scope="col"> نوع </th>

                                            <th scope="col"> عنوان </th>


                                        </tr>

                                    </thead>

                                    <tbody>

                                        <tr class="text-center" *ngFor="let item of lst_CommandList;let i=index">

                                            <th class="text-dark"> {{ i + 1 | faNum}} </th>

                                            <th class="text-dark"
                                                (click)="item.tiCommandType == 0 ? sendSMS(item) : sendGPRS(item)">

                                                <i class="fa fa-paper-plane fa-lg pointer text-primary"
                                                    title="ارسال"></i>

                                            </th>

                                            <th class="text-dark"> {{ item.strCommandType | faNum}} </th>

                                            <th class="text-dark"> {{ item.strTitle | faNum}} </th>

                                        </tr>

                                    </tbody>

                                </table>

                            </div>

                        </div>

                    </div>

                    <!-- نتیجه فرمان های ارسالی -->

                    <div *ngIf="!isCommandList" class="col-12 p-1">

                        <div class="w-100 h-100" style="max-height: 400px;overflow: auto;">

                            <div class="w-100">

                                <!-- اکسل -->

                                <button class="d-none btn btn-success" (click)="exportexcel(list-container)">

                                    خروجی اکسل

                                </button>

                                <!-- حذف -->

                                <ng-container *ngIf="lstChecked.length">

                                    <button class="btn btn-danger mx-2" (click)="removeSelected()">

                                        حذف

                                    </button>

                                </ng-container>

                            </div>

                            <div class="section border border-2 mt-2">

                                <div class="list-container" id="list-container">

                                    <div *ngFor="let item of lst_CommandList"
                                        class="response-item border-bottom border-2 p-2 pointer"
                                        [class.bg-smoke]="isSelected(item.id)"
                                        (click)="setCheckBox(!isSelected(item.id),item)">

                                        <div class="">

                                            <input type="checkbox" class="form-check-input"
                                                (change)="setCheckBox($event.target.checked,item)"
                                                [checked]="isSelected(item.id)">

                                        </div>

                                        <p class="mb-0 text-end" dir="ltr">

                                            <small> {{ item.result_value }} </small>

                                            <span class="text-muted pointer mx-2"
                                                (click)="copyToClipboard(item.result_value)">

                                                <i class="fa fa-clipboard" aria-hidden="true"></i>

                                            </span>

                                        </p>

                                        <p class="mb-0 text-muted">

                                            <small> {{ item.Column1 | faNum }} </small>

                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <div class="d-none d-flex justify-content-around flex-wrap">

                    <div class="col-lg-3 col-md-6 col-12 d-flex justify-content-center">

                        <button class="btn btn-th-blue w-200 mt-2" (click)="getSms(1)">راه اندازی مجدد</button>

                    </div>

                    <div class="col-lg-3 col-md-6 col-12 d-flex justify-content-center">

                        <button class="btn btn-th-blue w-200 mt-2" (click)="getSms(2)">دریافت موقعیت فعلی</button>

                    </div>

                    <div class="col-lg-3 col-md-6 col-12 d-flex justify-content-center">

                        <button class="btn btn-th-blue w-200 mt-2" (click)="getSms(3)">خاموش کردن خودرو</button>

                    </div>

                    <div class="col-lg-3 col-md-6 col-12 d-flex justify-content-center">

                        <button class="btn btn-th-blue w-200 mt-2" (click)="getSms(4)">روشن کردن خودرو</button>

                    </div>

                </div>

            </div>

            <div class="modal-footer">

                <button type="button" class="btn btn-outline-secondary " data-bs-dismiss="modal">

                    بستن

                </button>

            </div>

        </div>

    </div>

</div>

<!-- Document Modal -->

<div class="modal fade rtl " id="documentModal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content ">

            <div class="modal-header">

                <h5 class="modal-title"> {{bDocumentMode == 'viewMode' ?
                    documentModel.get('strEvidenceType_strComment')?.value + ' ( تاریخ اعتبار : ' +
                    (documentModel.get('strExpireDate')?.value | faNum) + ' ) ' : ' اسناد و مدارک '}}</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="dir modal-body">

                <ng-container *ngIf="bDocumentMode == 'documentMode' || bDocumentMode == 'deleteMode' ">

                    <div class="row gx-3 px-2 gy-2">

                        <div class="col-12 col-md-9 p-2">

                            <select (change)="documentOperation('','',$event)" class="form-control"
                                id="list_documentsType">

                                <option class="text-danger fw-bold text-center" disabled> جستجو بر اساس نوع نوع مدرک
                                </option>

                                <option value="-1"> همه مدارک </option>

                                <option *ngFor="let item of list_documentsType" value="{{item.tiEvidenceType}}">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <div *ngIf="acssess.bEvidenceDriver_Edit" class="col-12 col-md-3 p-2">

                            <button type="button" class="btn btn-success w-100"
                                (click)="documentOperation('','','search')"> سند جدید </button>

                        </div>

                        <div class="album-container row gx-2 gy-2 gy-md-0 w-100 border border-2 p-2">

                            <div *ngFor="let item of list_documents_Filter;let i = index"
                                class="document-box pointer col-12 col-md-4 p-2">

                                <div class="position-relative p-2 border border-2 rounded w-100 h-100">

                                    <img src="{{'data:image/jpeg;base64,' + item.strImage}}"
                                        alt="{{item.strEvidenceType_strComment}}">

                                    <div class="tag-document w-100 ">

                                        <i class="fa fa-trash  border border-2 border-dark bg-th-white text-danger p-2 px-2"
                                            (click)="bDocumentMode = 'deleteMode';documentOperation(item,i)"
                                            aria-hidden="true"></i>

                                        <i *ngIf="acssess.bEvidenceDriver_Edit"
                                            class="fa fa-pencil-square  border border-2 border-dark bg-th-white text-primary p-2 px-2 mx-1"
                                            (click)="editDocument(item,i)" aria-hidden="true"></i>

                                        <i class="fa fa-eye  border border-2 border-dark bg-th-white text-success p-2 px-2"
                                            (click)="bDocumentMode = 'viewMode';documentOperation(item,i)"
                                            aria-hidden="true"></i>

                                    </div>

                                </div>

                            </div>

                            <div *ngIf="!list_documents_Filter.length" class="text-center p-2"> موردی یافت نشد </div>

                        </div>

                    </div>

                </ng-container>

                <ng-container *ngIf="bDocumentMode == 'addMode' || bDocumentMode == 'editMode' ">

                    <form [formGroup]="documentModel" class="row gx-3 px-2 gy-2">

                        <div class="col-12 col-md-6">

                            <label> نوع مدرک </label>

                            <select formControlName="tiEvidenceType" class="form-control" id="list_documentsType">

                                <option *ngFor="let item of list_documentsType" value="{{item.tiEvidenceType}}">

                                    {{item.strComment}}

                                </option>

                            </select>

                        </div>

                        <div class="col-12 col-md-6">

                            <label> تاریخ پایان اعتبار </label>

                            <ng-persian-datepicker [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                                [dateFormat]="'jYYYY/jMM/jDD'">

                                <input type="text" formControlName="strExpireDate" class="form-control text-end" />

                            </ng-persian-datepicker>

                        </div>

                        <div (click)="fileInput.click()" class="image-uploader-container col-12 border border-2 p-2">

                            <img src="{{ documentModel.get('strImage').value != '' ? 'data:image/jpeg;base64,' + documentModel.get('strImage').value : '../../../assets/Img/gallery.jpg' }}"
                                alt="">

                            <p> تصویر خود را آپلود کنید </p>

                            <input hidden type="file" #fileInput (change)="onFileInput($event.target.files[0]);" />

                        </div>

                    </form>

                </ng-container>

                <ng-container *ngIf="bDocumentMode == 'viewMode' ">

                    <div class="w-100 h-100 col-12 border border-2 p-2">

                        <img class="w-100 h-100"
                            src="{{ 'data:image/jpeg;base64,' + documentModel.get('strImage').value}}" alt="">

                    </div>

                </ng-container>

            </div>

            <div dir="ltr" class="modal-footer">

                <button *ngIf="bDocumentMode == 'addMode' || bDocumentMode == 'editMode' " type="button"
                    class="px-4 btn" [ngClass]=" bDocumentMode == 'addMode' ? 'btn-success' : 'btn-primary' "
                    (click)="documentOperation()"> {{bDocumentMode == 'addMode' ? 'ذخیره' : 'ویرایش' }} </button>

                <button type="button" class="px-3 btn btn-danger"
                    (click)="bDocumentMode == 'addMode' || bDocumentMode == 'editMode' || bDocumentMode == 'viewMode' ? bDocumentMode = 'documentMode' : '' "
                    [attr.data-bs-dismiss]="bDocumentMode == 'documentMode' ? 'modal' : null"> {{bDocumentMode ==
                    'documentMode' || bDocumentMode == 'deleteMode' ? 'بستن' : 'بازگشت' }} </button>

            </div>

        </div>

    </div>

</div>

<!-- Operation Modal -->

<div class="modal fade rtl " id="Operation_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id=""> عملیات </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body row gx-2 gy-3 p-3">

                <!-- تعمیرات و سرویس -->

                <div class="col-12 col-md-3 col-lg-4" [routerLink]="['/repairs/',Id]" *ngIf="acssess.bRepairs"
                    data-bs-dismiss="modal" aria-label="Close">

                    <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                        <img src="../../../assets/Img/سوابق.png" class="img-person mx-auto mt-2">

                        <p class="text-center text-primary"> تعمیرات و سرویس </p>

                    </div>

                </div>

                <!-- سرویس های دوره ای -->

                <div class="col-12 col-md-3 col-lg-4" [routerLink]="['/services/',Id]" *ngIf="acssess.bService"
                    data-bs-dismiss="modal" aria-label="Close">

                    <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                        <img src="../../../assets/Img/سرویس-دوره-ای.png" class="img-person mx-auto mt-2">

                        <p class="text-center text-primary font-info-resp"> سرویس های دوره ای </p>

                    </div>

                </div>

                <!-- بازرسی ایمنی -->

                <div class="col-12 col-md-3 col-lg-4" [routerLink]="['/inspection/',Id]"
                    *ngIf="acssess.bFInspection_User" data-bs-dismiss="modal" aria-label="Close">

                    <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                        <img src="../../../assets/Img/HSE.png" class="img-person mx-auto mt-2">

                        <p class="text-center text-primary font-info-resp"> بازرسی ایمنی </p>

                    </div>

                </div>

                <!-- بازدید دوره ای -->

                <div class="col-12 col-md-3 col-lg-4" [routerLink]="['/periodic-visit/',Id]"
                    *ngIf="acssess.bPeriodicVisits_User" data-bs-dismiss="modal" aria-label="Close">

                    <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                        <img src="../../../assets/Img/بازدید دوره ای.png" class="img-person mx-auto mt-2">

                        <p class="text-center text-primary font-info-resp"> بازدید دوره ای </p>

                    </div>

                </div>

                <!-- درخواست خدمات و قطعه -->

                <div class="col-12 col-md-3 col-lg-4" [routerLink]="['/service-part',this.Id]"
                    *ngIf="acssess.bServiceParts_User" data-bs-dismiss="modal" aria-label="Close">

                    <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                        <img src="../../../assets/Img/درخواست خدمات و قطعه.png" class="img-person mx-auto mt-2">

                        <p class="text-center text-primary font-info-resp"> درخواست خدمات و قطعه </p>

                    </div>

                </div>

                <!-- دسترسی های موقت -->

                <div class="col-12 col-md-3 col-lg-4" (click)="goToTempAccess()" *ngIf="acssess.bTemporaryAccess"
                    data-bs-dismiss="modal" aria-label="Close">

                    <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                        <img src="../../../assets/Img/دسترسی های موقت.png" class="img-person mx-auto mt-2">

                        <p class="text-center text-primary font-info-resp"> دسترسی های موقت </p>

                    </div>

                </div>

                <!-- سوابق خلافی -->

                <div class="col-12 col-md-3 col-lg-4" [routerLink]="['/violations',this.Id]" data-bs-dismiss="modal"
                    aria-label="Close">

                    <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                        <img src="../../../assets/Img/سوابق خلافی .png" class="img-person mx-auto mt-2">

                        <p class="text-center text-primary font-info-resp"> سوابق خلافی </p>

                    </div>

                </div>

                <!-- کالیبراسیون باک -->

                <div class="col-12 col-md-3 col-lg-4" *ngIf="car?.bFuelSensor == 1" data-bs-dismiss="modal"
                    aria-label="Close" (click)="open_Calibration()">

                    <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                        <img src="../../../assets/Img/کالیبراسیون.png" class="img-person mx-auto mt-2">

                        <p class="text-center text-primary font-info-resp"> کالیبراسیون باک </p>

                    </div>

                </div>

                <!-- کالیبراسیون تانکر -->

                <div class="col-12 col-md-3 col-lg-4" *ngIf="car?.bTanker == 1" data-bs-dismiss="modal"
                    aria-label="Close" (click)="open_Calibration(true)">

                    <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                        <img src="../../../assets/Img/کالیبراسیون.png" class="img-person mx-auto mt-2">

                        <p class="text-center text-primary font-info-resp"> کالیبراسیون تانکر </p>

                    </div>

                </div>

                <!-- کالیبراسیون وزن -->

                <div class="col-12 col-md-3 col-lg-4" *ngIf="car?.bWeightSensor == 1" data-bs-dismiss="modal"
                    aria-label="Close" (click)="open_Calibration(false,true)">

                    <div class="col-11 pointer shadow d-flex justify-content-center flex-column rounded me-auto">

                        <img src="../../../assets/Img/کالیبراسیون.png" class="img-person mx-auto mt-2">

                        <p class="text-center text-primary font-info-resp"> کالیبراسیون وزن </p>

                    </div>

                </div>

            </div>

            <div class="modal-footer py-3"></div>

        </div>

    </div>

</div>

<!-- کالیبراسیون -->

<div class="modal fade" id="calibration_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> کالیبراسیون </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <p class="mb-2">

                    وقتی خودرو روشن و در سطح مسطح قرار دارد اطلاعات زیر را وارد و سپس دکمه ثبت را انتخاب کنید.

                </p>

                <small class="">

                    <b class="text-danger"> یادداشت : </b>

                    حداقل این عملیات را برای هر وضعیت دوبار تکرار کنید.

                </small>

                <div class="w-100 row gx-0 gy-0">

                    <form [formGroup]="mdl_Calibration" class="col-12 my-4">

                        <div class="form-check">

                            <input class="form-check-input" type="radio" name="tiStatus" id="flexRadioDefault1"
                                [value]="0" formControlName="tiStatus">

                            <label class="form-check-label" for="flexRadioDefault1">

                                {{ weight_Calibration ? 'بدون بار' : tanker_Calibration ? 'تانکر خالی است' : 'باک تقریبا
                                خالی است' }}

                            </label>

                        </div>

                        <div class="form-check mt-2">

                            <input class="form-check-input" type="radio" name="tiStatus" id="flexRadioDefault2"
                                [value]="1" formControlName="tiStatus">

                            <label class="form-check-label" for="flexRadioDefault2">

                                {{ weight_Calibration ? 'حداکثر وزن بار' : tanker_Calibration ? 'تانکر پر است' : 'باک
                                کاملا پر است ' }}

                            </label>

                        </div>

                        <div class="form-check mt-2">

                            <input class="form-check-input" type="radio" name="tiStatus" id="flexRadioDefault2"
                                [value]="2" formControlName="tiStatus">

                            <label class="form-check-label" for="flexRadioDefault2">

                                سایر

                            </label>

                        </div>

                        <div class="w-100 mt-3">

                            <input class="w-100 form-control" oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                [placeholder]="weight_Calibration ? 'وزن بار (کیلوگرم)' : tanker_Calibration ? 'ارتفاع مایع (میلیمتر)' : 'مقدار سوخت موجود در باک (لیتر)' "
                                formControlName="iFule">

                        </div>

                    </form>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="submit_Calibration()">

                    &nbsp; ثبت &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- سوخت خالص مصرفی -->

<div class="modal fade rtl " id="NetConsumed_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title"> سوخت خالص مصرفی </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body row gx-0 gy-0">

                <!-- نام خودرو -->

                <div class="position-relative col-12 col-md-4 p-2">

                    <p class="mb-0">

                        <span class="fw-bold text-muted"> نام خودرو : </span>

                        <span class=""> {{ obj_NetConsumed?.strFullName }} </span>

                    </p>

                </div>

                <!-- تاریخ شروع -->

                <div class="position-relative col-12 col-md-4 p-2">

                    <p class="mb-0">

                        <span class="fw-bold text-muted"> تاریخ شروع : </span>

                        <span class=""> {{ obj_NetConsumed?.strSDate | faNum }} </span>

                    </p>

                </div>

                <!-- تاریخ پایان -->

                <div class="position-relative col-12 col-md-4 p-2">

                    <p class="mb-0">

                        <span class="fw-bold text-muted"> تاریخ پایان : </span>

                        <span class=""> {{ obj_NetConsumed?.strEDate | faNum }} </span>

                    </p>

                </div>

                <!-- مقدار سوختگیری -->

                <div class="position-relative col-12 col-md-4 p-2">

                    <p class="mb-0">

                        <span class="fw-bold text-muted"> مقدار سوختگیری : </span>

                        <span class=""> {{ obj_NetConsumed?.TotalRefueling | faNum }} لیتر </span>

                    </p>

                </div>

                <!-- مقدار برداشت مشکوک -->

                <div class="position-relative col-12 col-md-4 p-2">

                    <p class="mb-0">

                        <span class="fw-bold text-muted"> مقدار برداشت مشکوک : </span>

                        <span class=""> {{ obj_NetConsumed?.TotalHarvesting | faNum }} لیتر </span>

                    </p>

                </div>

                <!-- موجودی باک -->

                <div class="position-relative col-12 col-md-4 p-2">

                    <p class="mb-0">

                        <span class="fw-bold text-muted"> موجودی باک : </span>

                        <span class=""> {{ obj_NetConsumed?.EndTankValue | faNum }} لیتر </span>

                    </p>

                </div>

                <!-- مصرف -->

                <div class="position-relative col-12 col-md-4 p-2">

                    <p class="mb-0">

                        <span class="fw-bold text-muted"> مصرف : </span>

                        <span class=""> {{ obj_NetConsumed?.RealConsumption.toFixed(2) | faNum }} لیتر </span>

                    </p>

                </div>

            </div>

            <div dir="ltr" class="modal-footer">

                <button type="button" class="btn btn-outline-secondary " data-bs-dismiss="modal">

                    بستن

                </button>

            </div>

        </div>

    </div>

</div>